import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared.module';
import { WidgetsComponentsModule } from 'src/app/components/kit/widgets/widgets-components.module';
import { FormsModule } from '@angular/forms';
import { IORouterModule } from './io-routing.module';
import { HardwareSpielwieseComponent } from './hardware/hardware.component';

const COMPONENTS = [HardwareSpielwieseComponent];

@NgModule({
	imports: [
		SharedModule,
		IORouterModule,
		WidgetsComponentsModule,
		FormsModule,
	],
	declarations: [...COMPONENTS]
})
export class IOModule {}
